import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';


import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';


export const DeferredJob = gql`
  fragment DeferredJob on Job {
    id
    accountingState: accounting_state
    invoice_state
    sage_sendable
    sage_info
    month_lease_invoice {
      date {
        display
      }
    }
    ticket_count
    lease {
      id
      name
      operator {
        id
        name
      }
      tax_schedule {
        id
        description
      }
      customer {
        id
        customer_name
      }
    }
    pdf_path
  }
`;


export const JobInvoiceableDeferredInbox = gql`
  query DeferredJobs {
    jobs_for_approval_inbox(deferred: true) {
      edges {
        node {
          ...DeferredJob
        }
      }
    }
  }
  ${DeferredJob}
`;


const mapDataToProps = withProps((props) => {
  const { data } = props;
  const jobs = querySelector(data, '$.jobs_for_approval_inbox.edges[*].node', []);
  return {
    jobs,
  };
});


const withData = graphql(JobInvoiceableDeferredInbox, {
  options: {
    fetchPolicy: 'network-only',
    pollInterval: 1000 * 60,
  },
});


const enhance = compose(
  withData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);


export default enhance;
